import { combineTokens } from '@utils/css';

const tokens = combineTokens("--slider-carousel", {
  itemsPerPage: 4
});
const wrapper = "_b7nwzue1l2";
const slider = "_b7nsb7uq1b";
const navigationButton = "_b7nn4stbbr";

export { navigationButton, slider, tokens, wrapper };
import "./_carousel.style.linaria.module.css";
//# sourceMappingURL=_carousel.style.js.map
